import { atom } from "jotai";
import { clamp, sortBy } from "lodash";
import { ArtbookPages, requirePage } from "@/components/pageTextureLoader";
import { CONFIG } from "@/config";
import { UrlLocale } from "../ubisoft/locale";
import { ARTBOOK_LOCALES, DEFAULT_LOCALE } from "../locales";
import { CameraIntroComplete } from "./camera";
import { Tracklist } from "@/meta/Tracklist";
export * from "./camera";
export * from "./fullscreen";
export * from "./volumes";
export var PagesAtom = atom(function (get) {
    var locale = get(ArtbookLocale);
    return new ArtbookPages(sortBy(requirePage.keys().filter(function (s) { return s.startsWith("./".concat(locale, "/")); }), function (name) {
        var match = name.match(CONFIG.textures.filePattern);
        if (match == null)
            throw new Error("Wrong filename: ".concat(name));
        return parseInt(match[1]);
    }));
});
var CurrentSheetAtomData = atom(0);
export var CurrentSheetAtom = atom(function (get) { return get(CurrentSheetAtomData); }, function (get, set, value) {
    var pages = get(PagesAtom);
    var current = get(CurrentSheetAtomData);
    var newValue = value === "prev" ? current - 1 : value === "next" ? current + 1 : value;
    set(CurrentSheetAtomData, clamp(newValue, 0, pages.getSheetCount() - 1));
});
export var FooterVisible = atom(true);
export var LanguageSelectorVisible = atom(function (get) { return !get(FooterVisible); });
var OverElementData = atom(null);
export var OverElement = atom(function (get) {
    return get(OverElementData) != null;
}, function (get, set, update) {
    if (update.action === "reset") {
        set(OverElementData, null);
    }
    else if (update.action === "over") {
        set(OverElementData, update.element);
    }
    else {
        var current = get(OverElementData);
        if (current === update.element) {
            set(OverElementData, null);
        }
    }
});
var PageOverElementData = atom(null);
export var PageOverElement = atom(function (get) {
    return get(PageOverElementData);
}, function (get, set, update) {
    if (update.action === "reset") {
        set(PageOverElementData, null);
    }
    else if (update.action === "over") {
        set(PageOverElementData, update.element);
    }
    else {
        var current = get(PageOverElementData);
        if (current === update.element) {
            set(PageOverElementData, null);
        }
    }
});
export var MouseOverClickablePage = atom(function (get) {
    var page = get(PageOverElement);
    var currentSheet = get(CurrentSheetAtom);
    var pages = get(PagesAtom);
    var introComplete = get(CameraIntroComplete);
    if (!introComplete)
        return false;
    if (page === "left") {
        return currentSheet > 0;
    }
    if (page === "right") {
        return currentSheet < pages.getSheetCount() - 1;
    }
    return false;
});
export var DownloadPopupVisible = atom(false);
export var PageSelectorVisible = atom(false);
export var InstructionsPopupVisible = atom(true);
export var ArtbookLocale = atom(function (get) {
    var locale = get(UrlLocale);
    var lang = locale === null || locale === void 0 ? void 0 : locale.split("-")[0];
    return lang != null && ARTBOOK_LOCALES.includes(lang) ? lang : DEFAULT_LOCALE;
});
export var ArtbookLoaded = atom(false);
export var SoundtrackEnabled = atom(function () { return Tracklist.length > 0; });
